<template>
	<!--  -->
	<div :id="id" class="posR">
		<Confirm v-if="useFor!='showArea'" :id="'mapConfirm'" ref="Confirm"></Confirm>
		<Loading :id="'rootLoadingMap'" ref="Loading"></Loading>
		<div v-show="useFor!='showArea'" class="search w35x">
			<div v-show="drawStatus===0" class="cb">
				<InputText id="autoCompleteSearch" ref="autoCompleteSearch" v-model="searchKeyword" name="PositionSearchKey" :maxLength="100" class="w28x fL" :addClass="'bgContent'" :placeholder="getLanguageStr('phrase431','输入地址搜索电站位置')" :fn="searchInput"></InputText>
				<button class="functionBtn w6x sizeM textCut fR" :class="{disable:!searchKeyword,bgContent:!searchKeyword}" @click="searchInput(searchKeyword)" type="button">{{$t('cmd90',['搜索'])}}</button>
			</div>
			<button v-show="drawStatus>0" class="functionBtn" type="button" @click="backToSearch"><i class="fa fa-angle-left mr05x"></i>{{$t('cmd160',['返回重新搜索'])}}</button>
		</div>

		<div v-if="useFor!='showArea'" v-show="plantName||drawStatus===3" class="report w35x bgContent boxR">
			<Loading :id="'loadingIRR'" class="boxR ofH" ref="loadingIRR"></Loading>
			<slot name="reportContent"></slot>
			<div class="bdSub-top pl1x pr1x pt1x pb1x taC">
				<button v-if="drawStatus===0" class="w90pct mc dpB sizeM bdMain cMain boxR hover-bg-main tra-fast" type="button" @click="startDraw">{{$t('cmd158',['开始绘制屋顶面积'])}}</button>
				<button v-if="drawStatus===1" class="w90pct mc dpB sizeM bdMain cMain boxR hover-bg-main tra-fast" type="button" @click="reDraw">{{$t('cmd159',['重新绘制屋顶面积'])+"(Esc)"}}</button>
				<div v-if="drawStatus===3" class="tableSys vaM_E">
					<div class="taL lh13">
						IRR<span class="ml05x fs16x">{{customData+"%"}}</span>
						<div v-if="customData<=1" class="cMain">{{$t('phrase568',['项目有风险，投资请谨慎。'])}}</div>
						<div v-if="customData>1&&customData<10" class="cMain">{{$t('phrase569',['收益尚可，可深入探讨。'])}}</div>
						<div v-if="customData>=10" class="cMain">{{$t('phrase570',['项目不错，值得投资！'])}}</div>
					</div>
					<div class="w40pct taR">
						<button class="w100pct-max pl05x pr05x pt05x pb05x bdMain cMain boxR hover-bg-main lh13 tra-fast" type="button" @click="$emit('New',true)">{{$t('cmd161',['查看详细报告'])}}</button>
					</div>
				</div>
			</div>
		</div>

		<div class="mapBox">
			<div class="map amap googleMap bgLight" :class="{h20x:useFor=='showArea',h30x:useFor=='new','boxR-light':useFor=='new',curCross:drawStatus===1}">
			</div>
			<button class="toolbar toolbar-satellite" style="background-color:#fff;" :status="satellite.status?'on':'off'" @click="doSatellite" type="button">
				<Icon name="satellite-off" class="off fSub"/>
				<Icon name="satellite-on" class="on fMain"/>
			</button>
			<button class="toolbar toolbar-locate fSub" style="background-color:#fff;" @click="getAutoLocation" type="button">
				<Icon name="posArrow-up"/><!--crosshair-->
			</button>
			<div class="tip taC"><span class="text boxR bgMain tra">{{tip}}</span></div>
		</div>
		<div v-if="drawStatus===1" class="trackTip bgContent boxR peN">{{trackTip}}</div>
		<div v-if="useFor=='new'" class="mt2x">
			<span class="cWarning" :title="getLanguageStr('word674','区域')">* </span><span class="cSub">{{getLanguageStr('word674+: ','区域: ')}}</span>
			<div class="mt1x">
				<Select v-if="addressCode.lv1.list.length" @Click="addressCodelv1Change" v-model="addressCode.lv1.id" :list="addressCode.lv1.list" :size="'m'" class="w10x" :keyMap="{text:'name',value:'id'}" :bindActive="addressCode.lv1.id" bindMode="target"></Select>
				<Select v-if="addressCode.lv2.list.length" @Click="addressCodelv2Change" v-model="addressCode.lv2.id" :list="addressCode.lv2.list" :size="'m'" class="w10x" :keyMap="{text:'name',value:'id'}" :bindActive="addressCode.lv2.id" bindMode="target"></Select>
				<Select v-if="addressCode.lv3.list.length" @Click="addressCodelv3Change" v-model="addressCode.lv3.id" :list="addressCode.lv3.list" :size="'m'" class="w10x" :keyMap="{text:'name',value:'id'}" :bindActive="addressCode.lv3.id" bindMode="target"></Select>
				<Select v-if="addressCode.lv4.list.length" @Click="addressCodelv4Change" v-model="addressCode.lv4.id" :list="addressCode.lv4.list" :size="'m'" class="w10x" :keyMap="{text:'name',value:'id'}" :bindActive="addressCode.lv4.id" bindMode="target"></Select>
				<Select v-if="addressCode.lv5.list.length" @Click="addressCodelv5Change" v-model="addressCode.lv5.id" :list="addressCode.lv5.list" :size="'m'" class="w10x" :keyMap="{text:'name',value:'id'}" :bindActive="addressCode.lv5.id" bindMode="target"></Select>
				<Select v-if="addressCode.lv6.list.length" @Click="addressCodelv6Change" v-model="addressCode.lv6.id" :list="addressCode.lv6.list" :size="'m'" class="w10x" :keyMap="{text:'name',value:'id'}" :bindActive="addressCode.lv6.id" bindMode="target"></Select>
			</div>
		</div>
		<div v-if="useFor=='new'" class="mt2x cSub">
			<!-- <div class="mb1x cSub">{{$t("phrase543",["请确认电站地址和位置"])}}</div> -->
			<span class="cWarning" :title="getLanguageStr('word848','地址')">* </span><span>{{getLanguageStr('word848+: ','地址: ')}}</span>
			<InputText class="w100pct mt1x" v-model="myLocation.address" name="locationAddress" :verification="'notEmpty'" :max-length="200" ref="plantAddress"></InputText>
		</div>
		<div v-if="useFor=='new'" class="mt2x cSub" :title="getLanguageStr('word1691','经纬度')">
			<span class="cWarning">* </span>{{getLanguageStr('word1691+:','经纬度:')}}
		</div>
		<div v-if="useFor=='new'" class="mt1x dpIB_E">
			<div class="dpIB mr05x_E">
				<span>{{getLanguageStr('word839','经度')}}</span>
				<InputText class="w5x dpIB" v-model="myLocation.lngLv.lv1" name="lngLv1" :only="'int'" :verification="'notEmpty,~:-180~180'" @Blur="blur" :maxLength="4" ref="lng1"></InputText><span class="fs14x mr1x">°</span>
				<InputText class="w5x dpIB" v-model="myLocation.lngLv.lv2" name="lngLv2" :only="'absInt'" :verification="'notEmpty,<=:60'" @Blur="blur" :maxLength="2" ref="lng2"></InputText><span class="fs14x mr1x">′</span>
				<InputText class="w5x dpIB" v-model="myLocation.lngLv.lv3" name="lngLv3" :only="'absNumber'" :verification="'notEmpty,<=:60'" @Blur="blur" :maxLength="5" ref="lng3"></InputText><span class="fs14x">″</span>
			</div>
			<div class="dpIB mr05x_E">
				<span>{{getLanguageStr('word840','纬度')}}</span>
				<InputText class="w5x dpIB" v-model="myLocation.latLv.lv1" name="latLv1" :only="'int'" :verification="'notEmpty,~:-90~90'" @Blur="blur" :maxLength="4" ref="lat1"></InputText><span class="fs14x mr1x">°</span>
				<InputText class="w5x dpIB" v-model="myLocation.latLv.lv2" name="latLv2" :only="'absInt'" :verification="'notEmpty,<=:60'" @Blur="blur" :maxLength="2" ref="lat2"></InputText><span class="fs14x mr1x">′</span>
				<InputText class="w5x dpIB" v-model="myLocation.latLv.lv3" name="latLv3" :only="'absNumber'" :verification="'notEmpty,<=:60'" @Blur="blur" :maxLength="5" ref="lat3"></InputText><span class="fs14x">″</span>
			</div>
		</div>
	</div>
</template>
<script>
import axios from 'axios';
import {getTypeText, floatFix, objTool} from '@/util/lib.js';
import {getLanguageStr} from '@/util/language.js';
import message from '@/plugins/message/index.js';

import Loading from '@/components/common/ui/Loading';
import InputText from '@/components/common/ui/InputText.vue';
import Confirm from '@/components/common/ui/Confirm.vue';
import Select from '@/components/common/ui/Select.vue';

import {searchAreaDetailsByLatlon, searchAreaList, apiGetCountry} from '@/api/base.js';
import {apiGetIrradiationData} from '@/api/bench/evaluation.js';

export default {
	name: 'SearchPosition',
	components: {Loading, InputText, Confirm, Select},
	props: {
		isEdit: {
			type: Boolean,
			default: false
		},
		// address:{
		// 	type:String,
		// 	default:""
		// },
		location: {
			type: Object,
			default: function () {
				return {
					lng: '',
					lat: '',
					address: ''
				};
			}
		},
		defaultRegion: {
			type: Object,
			default: {
				level1: '',
				level2: '',
				level3: '',
				level4: '',
				level5: '',
				nationId: 0,
				timezone: ''
			}
		},
		useFor: {// 用于新建电站、绘制地点
			type: String,
			default: 'new'// draw,showArea
		},
		customData: {// 用于新建电站、绘制地点
			type: [String, Number, Object],
			default: ''// draw
		},
		areaPoint: {// 用于展示绘制地点
			type: Array,
			default: null
		}
		// addClass:{//激活的索引项
		// 	type:[String,Object],
		// 	default:""
		// },
	},
	data () {
		return {
			id: 'SearchPosition' + Math.round(Math.random() * 99999),

			type: '', // amap,googleMap
			verification: 'notEmpty',
			map: {
				active: '',

				country: 'CN', // getLanguageStr('country1','中国')

				amap: null,
				googleMap: null
			},
			googleMapMaker: [],
			option: {
				amap: {
					center: [107.490234375, 35.10193405724606], // [lng,lat]
					resizeEnable: true, // 是否监控地图容器尺寸变化
					scrollWheel: false, // 地图是否可通过鼠标滚轮缩放浏览
					showIndoorMap: false,
					isHotspot: false, // 是否开启地图热点和标注的hover效果
					zoom: 4, // 18
					lang: (function () {
						if (stage.languageId == 'zh') { // 高德的国际化处理
							return stage.languageId + '_cn';
						} else {
							return 'en';
						}
					}())
				},
				googleMap: {
					center: {lat: 35.10193405724606, lng: 107.490234375},
					// maxZoom:18,
					controlSize: 35,
					minZoom: 3,
					enableGoogleBar: true,
					scrollwheel: false,
					panControl: false,
					mapTypeControl: false,
					streetViewControl: false,
					overviewMapControl: false,
					rotateControl: false,
					clickableIcons: false,
					tilt: 0,
					// scaleControl:true,
					// zoomControl:true,

					fullscreenControl: false,
					zoom: 4
				}
			},
			markerList: [], // 记录marker列表
			lib: {// 登记第三方总程序
				amap: null,
				googleMap: null
			},
			satellite: {// 地图卫星层
				status: false, // 开关状态
				amap: null,
				googleMap: null
			},
			drawStatus: 0, // 绘制状态:0:初始状态，1:绘制阶段，2:绘制结束，等待IRR计算，3：出IRR结果
			area: null, // 区域对象
			line: null, // 记录范围的描边
			mouseLnglat: [], // 鼠标在地图上的经纬度[lng,lat]

			// myLocation:{
			// 	address:this.location.address
			// },
			plantName: '', // 电站名称
			addressCode: {// 存储查找到的有效ID
				lv1: {id: 0, list: []},
				lv2: {id: '', list: []},
				lv3: {id: '', list: []},
				lv4: {id: '', list: []},
				lv5: {id: '', list: []},
				lv6: {id: '', list: []}
			},
			myLocation: {
				lng: '',
				lat: '', // 107.490234375,35.10193405724606
				address: this.location.address,
				lngLv: {lv1: '', lv2: '', lv3: '', lv4: ''},
				latLv: {lv1: '', lv2: '', lv3: '', lv4: ''}
			},

			roofType: getTypeText('', 'roofType', true)[0].id[0], // 屋顶类型
			areaData: 0, // 屋顶面积
			myAreaPoint: this.areaPoint, // 区域锚点
			OA: null, // 预测光照小时
			// azimuth:180,//方位角
			// roofDip:26,//屋顶倾角
			IRR: 0, // Math.max(...[])
			IRRtext: '',

			searchKeyword: '', // 搜索地址
			trackTip: '', // 跟踪提示
			tip: ''// 地图交互提示
		};
	},
	watch: {
		'location': {
			deep: true,
			handler: function () {
				if (this.location.lng != this.myLocation.lng || this.location.lat != this.myLocation.lat) {
					this.setPositionLv(this.location.lng, this.location.lat);
					// setMarker([this.location]);
					// this.getPosition()
				}
				this.myLocation.address = this.location.address;
			}
		},
		'myLocation.address': function () {
			this.$emit('Update', this.outPackData());
		},
		'roofDip': function (val) { // 始终检测数据并恢复默认值
			if (this.roofType == libetTypeText('', 'roofType', true)[0].id[0]) {
				this.$nextTick(() => {
					this.$set(this, 'roofDip', 26);
				});
			}
		},
		areaPoint: function () {
			if (this.useFor == 'showArea') {
				this.myAreaPoint = this.areaPoint;
				this.clearMap();
				this.$refs.Loading.show();
				this.mapLoaded();
			}
		},
		'addressCode.lv1.id': function () { // 监听国家选择变化
			let finded = objTool(this.addressCode.lv1.list, 'findByKey', ['id', this.addressCode.lv1.id])[1];
			if (finded) {
				// trace(finded,true)
			}
		}
		// 'addressCode.lv2.id': function () { // 监听国家选择变化
		// 	let finded = objTool(this.addressCode.lv2.list, 'findByKey', ['id', this.addressCode.lv2.id])[1]
		// 	if (finded) {
		// 		// trace(finded,true)
		// 	}
		// },
		// 'addressCode.lv3.id': function () { // 监听国家选择变化
		// 	let finded = objTool(this.addressCode.lv3.list, 'findByKey', ['id', this.addressCode.lv3.id])[1]
		// 	if (finded) {
		// 		// trace(finded,true)
		// 	}
		// },
		// 'addressCode.lv4.id': function () { // 监听国家选择变化
		// 	let finded = objTool(this.addressCode.lv4.list, 'findByKey', ['id', this.addressCode.lv4.id])[1]
		// 	if (finded) {
		// 		// trace(finded,true)
		// 	}
		// },
		// 'addressCode.lv5.id': function () { // 监听国家选择变化
		// 	let finded = objTool(this.addressCode.lv5.list, 'findByKey', ['id', this.addressCode.lv5.id])[1]
		// 	if (finded) {
		// 		// trace(finded,true)
		// 	}
		// }
		// drawStatus:function(val){
		// 	trace(val)
		// }
	},
	methods: {
		getLanguageStr,
		getTypeText: getTypeText,
		reset: function (data) {
			// trace(data);
			this.searchKeyword = '';
			this.myAreaPoint = this.areaPoint;
			this.clearMap();
			$.each(this.$refs, function () { // 遍历范围内所有需要reset对象,以清除一些报错内容
				// trace(this);
				if (this.reset) this.reset();
			});
			this.addressCode = {// 清除code
				lv1: {id: 0, parentId: 0, list: []},
				lv2: {id: '', list: []},
				lv3: {id: '', list: []},
				lv4: {id: '', list: []},
				lv5: {id: '', list: []},
				lv6: {id: '', list: []}
			};
			if (data) {
				if (this.useFor == 'new') { // 编辑电站
					// $.extend(true, this.myLocation, data);
					this.myLocation.lng = data.lng;
					this.myLocation.lat = data.lat;
					this.myLocation.address = data.address;
					this.addressCode.lv1.id = data.region.nationId;
					this.addressCode.lv2.id = data.region.level1;
					this.addressCode.lv3.id = data.region.level2;
					this.addressCode.lv4.id = data.region.level3;
					this.addressCode.lv5.id = data.region.level4;
					this.addressCode.lv6.id = data.region.level5;

					this.setPositionLv(data.lng, data.lat);
					// this.getPosition()
				} else if (data.area) {
					this.drawStatus = 3;
					this.plantName = data.name;
					this.myAreaPoint = data.area;
					this.myLocation.address = data.address;
				}
			} else {
				if (this.useFor == 'new') {
					this.initAreaList();
				}
				this.drawStatus = 0;
				this.plantName = '';

				$.extend(true, this.myLocation, {
					// lngLv:{lv1:121,lv2:28,lv3:20},
					// latLv:{lv1:31,lv2:13,lv3:52}
					lngLv: {lv1: '', lv2: '', lv3: ''},
					latLv: {lv1: '', lv2: '', lv3: ''}
				});
				// this.myLocation.lng=this.timeToLngLat(this.myLocation.lngLv);
				// this.myLocation.lat=this.timeToLngLat(this.myLocation.latLv);
				this.myLocation.lng = null;
				this.myLocation.lat = null;
				// if(this.location.lng==""||this.location.lat==""){
				// }
				this.myLocation.address = this.location.address;
			}
			this.$emit('Update', this.outPackData());
		},
		clearSubAddressCode (i, parentId) {
			let isCN = this.addressCode.lv1.id;
			let firstArray = [
				{token: true, id: null, def: getLanguageStr('word1735', '国家/地区')},
				{token: true, id: null, def: getLanguageStr('word1735', '国家/地区')},
				{name: getLanguageStr('cmd19', '全部'), id: null, def: isCN == 44 ? getLanguageStr('word676', '省') : i18n.t('fill3rd156', [1, '1级区域'])},
				{name: getLanguageStr('cmd19', '全部'), id: null, def: isCN == 44 ? getLanguageStr('word677', '市') : i18n.t('fill3rd156', [2, '2级区域'])},
				{name: getLanguageStr('cmd19', '全部'), id: null, def: isCN == 44 ? getLanguageStr('word889', '区') : i18n.t('fill3rd156', [3, '3级区域'])},
				{name: getLanguageStr('cmd19', '全部'), id: null, def: isCN == 44 ? getLanguageStr('word806', '请选择') : i18n.t('fill3rd156', [4, '4级区域'])},
				{name: getLanguageStr('cmd19', '全部'), id: null, def: isCN == 44 ? getLanguageStr('word806', '请选择') : i18n.t('fill3rd156', [5, '5级区域'])},
				{name: getLanguageStr('cmd19', '全部'), id: null, def: isCN == 44 ? getLanguageStr('word806', '请选择') : i18n.t('fill3rd156', [6, '6级区域'])}
			];
			searchAreaList(parentId).then(res => {
				// console.log(111)
				if (res.length) {
					//					let rgInfo = res[0];
					//					this.addressCode['lv'+i]={...rgInfo};
					this.addressCode['lv' + i].list = [firstArray[i]].concat(res);
					this.$emit('Update', this.outPackData());
					//					this.setPositionLv(this.addressCode['lv'+(i)].longitude,this.addressCode['lv'+(i)].latitude);
					//					this.setMarker([{lng:this.addressCode['lv'+(i)].longitude,lat:this.addressCode['lv'+(i)].latitude}]);
				} else {
					//					this.setCenter(this.addressCode['lv'+(i-1)].longitude,this.addressCode['lv'+(i-1)].latitudethis.addressCode['lv'+(i)].longitude,this.addressCode['lv'+(i)].latitude)
					//					this.setPositionLv(this.addressCode['lv'+(i-1)].longitude,this.addressCode['lv'+(i-1)].latitude);
					//					this.setMarker([{lng:this.addressCode['lv'+(i-1)].longitude,lat:this.addressCode['lv'+(i-1)].latitude}]);
				}
			}, error => { });
		},
		addressChangeFit (i) {
			if (this.map.active == 'amap') {
				switch (i) {
				case 1:
					this.map.amap.setZoomAndCenter(4, new AMap.LngLat(this.addressCode['lv' + (i)].longitude, this.addressCode['lv' + (i)].latitude));
					break;
				case 2:
					this.map.amap.setZoomAndCenter(7, new AMap.LngLat(this.addressCode['lv' + (i)].longitude, this.addressCode['lv' + (i)].latitude)); break;
				case 3:
					this.map.amap.setZoomAndCenter(10, new AMap.LngLat(this.addressCode['lv' + (i)].longitude, this.addressCode['lv' + (i)].latitude)); break;
				case 4:
					this.map.amap.setZoomAndCenter(12, new AMap.LngLat(this.addressCode['lv' + (i)].longitude, this.addressCode['lv' + (i)].latitude)); break;
				case 5:
					this.map.amap.setZoomAndCenter(15, new AMap.LngLat(this.addressCode['lv' + (i)].longitude, this.addressCode['lv' + (i)].latitude)); break;
				case 6:
					this.map.amap.setZoomAndCenter(18, new AMap.LngLat(this.addressCode['lv' + (i)].longitude, this.addressCode['lv' + (i)].latitude)); break;
				}
			} else {
				let mapcenter = new google.maps.LatLng(this.addressCode['lv' + (i)].latitude, this.addressCode['lv' + (i)].longitude);
				switch (i) {
				case 1:
					this.map.googleMap.setZoom(4);
					break;
				case 2:
					this.map.googleMap.setZoom(7);
					break;
				case 3:
					this.map.googleMap.setZoom(10);
					break;
				case 4:
					this.map.googleMap.setZoom(12);
					break;
				case 5:
					this.map.googleMap.setZoom(15);
					break;
				case 6:
					this.map.googleMap.setZoom(18);
					break;
				}
				this.map.googleMap.setCenter(mapcenter);
				// console.log(this.addressCode['lv' + (i)].longitude,i)
				//             this.setPositionLv(this.addressCode['lv' + (i)].longitude, this.addressCode['lv' + (i)].latitude)
			}
		},
		addressCodelv1Change (index) {
			this.addressCode.lv1 = {...this.addressCode.lv1, ...this.addressCode.lv1.list[index]};
			// console.log(this.addressCode.lv1)
			this.addressChangeFit(1);
			this.addressCode.lv2 = {id: '', list: []};
			this.addressCode.lv3 = {id: '', list: []};
			this.addressCode.lv4 = {id: '', list: []};
			this.addressCode.lv5 = {id: '', list: []};
			this.addressCode.lv6 = {id: '', list: []};
			this.clearSubAddressCode(2, this.addressCode.lv1.id);
		},
		addressCodelv2Change (index) {
			this.addressCode.lv2 = {...this.addressCode.lv2, ...this.addressCode.lv2.list[index]};
			if (this.addressCode.lv2.list[index].id) {
				this.addressChangeFit(2);
				this.clearSubAddressCode(3, this.addressCode.lv2.id);
			}
			this.addressCode.lv3 = {id: '', list: []};
			this.addressCode.lv4 = {id: '', list: []};
			this.addressCode.lv5 = {id: '', list: []};
			this.addressCode.lv6 = {id: '', list: []};
			this.$emit('Update', this.outPackData());
		},
		addressCodelv3Change (index) {
			this.addressCode.lv3 = {...this.addressCode.lv3, ...this.addressCode.lv3.list[index]};
			if (this.addressCode.lv3.list[index].id) {
				this.addressChangeFit(3);
				this.clearSubAddressCode(4, this.addressCode.lv3.id);
			}
			this.addressCode.lv4 = {id: '', list: []};
			this.addressCode.lv5 = {id: '', list: []};
			this.addressCode.lv6 = {id: '', list: []};
			this.$emit('Update', this.outPackData());
		},
		addressCodelv4Change (index) {
			this.addressCode.lv4 = {...this.addressCode.lv4, ...this.addressCode.lv4.list[index]};
			if (this.addressCode.lv4.list[index].id) {
				this.addressChangeFit(4);
				this.clearSubAddressCode(5, this.addressCode.lv4.id);
			}
			this.addressCode.lv5 = {id: '', list: []};
			this.addressCode.lv6 = {id: '', list: []};
			this.$emit('Update', this.outPackData());
		},
		addressCodelv5Change (index) {
			this.addressCode.lv5 = {...this.addressCode.lv5, ...this.addressCode.lv5.list[index]};
			if (this.addressCode.lv5.list[index].id) {
				this.addressChangeFit(5);
				this.clearSubAddressCode(6, this.addressCode.lv5.id);
			}
			this.addressCode.lv6 = {id: '', list: []};
			this.$emit('Update', this.outPackData());
		},
		addressCodelv6Change (index) {
			this.addressCode.lv6 = {...this.addressCode.lv6, ...this.addressCode.lv6.list[index]};
			if (this.addressCode.lv6.list[index].id) {
				this.addressChangeFit(6);
			}
			this.$emit('Update', this.outPackData());
		},
		nsChange: function () { // 切换南北半球的修正
			if (this.myLocation.lat <= 0 && this.azimuth == 180) this.azimuth = 0;
			else if (this.myLocation.lat > 0 && this.azimuth == 0) this.azimuth = 180;
		},
		outPackData: function () {
			let out = {};
			$.extend(true, out, {
				name: this.searchKeyword || this.plantName,
				drawStatus: this.drawStatus,
				areaData: this.areaData,
				areaPoint: this.markerList,
				OA: this.OA,
				// lng:this.timeToLngLat(this.myLocation.lngLv)||"",
				// lat:this.timeToLngLat(this.myLocation.latLv)||"",
				lng: this.myLocation.lng,
				lat: this.myLocation.lat,
				address: this.myLocation.address,
				defaultCurrency: this.addressCode.lv1.defaultCurrency,
				defaultTimezone: this.addressCode.lv1.defaultTimezone
			}, this.addressCode);
			return out;
		},
		setTip: function (text) {
			let $this = this;
			this.tip = text;
			$(this.$el).find('.map').nextAll('.tip').addClass('open');
			setTimeout(function () {
				$($this.$el).find('.map').nextAll('.tip').removeClass('open');
			}, 1000 * 5);
		},
		selectAutoComplete: function (e) { // 自动填充地址，当选中某条记录时会触发
			// trace(e,true);
			switch (this.map.active) {
			case 'amap':
				this.searchKeyword = e.poi.name;
				if (e.poi.location) {
					this.myLocation.address = this.searchKeyword;// 自动设置地址
					this.setPositionLv(e.poi.location.lng, e.poi.location.lat);
					this.setMarker([{lng: e.poi.location.lng, lat: e.poi.location.lat}], true);
				}
				break;
			}
		},
		searchInput: function (text) {
			this.plantName = '';
			let $this = this;
			switch (this.map.active) {
			case 'amap':
				$('.amap-sug-result').css({'visibility': 'hidden'});// 执行搜索，隐藏候选下拉
				let map = this.map.amap;
				map.searchInput.search(text, function (status, data) {
					// trace(data,true);
					if ($this.useFor == 'new') $this.$set($this.myLocation, 'address', $this.searchKeyword);// 自动设置地址
					else if ($this.useFor == 'draw') {
						// $this.$set($this,"name",$this.searchKeyword);
						$this.name = $this.searchKeyword;
						// $this.$set($this.myLocation,"address",);
					}
					if ($.isEmptyObject(data) == false && data.poiList.count > 0) {
						let list = [];
						$.each(data.poiList.pois, function () {
							list.push({
								lng: this.location.lng,
								lat: this.location.lat,
								title: this.name + ' ' + this.address
							});
						});
						if (data.poiList.count == 1) {
							$this.setPositionLv(data.poiList.pois[0].location.lng, data.poiList.pois[0].location.lat);
						} else $this.setTip(getLanguageStr('phrase544', '搜索到多个符合的结果，请在地图中选择一个作为电站位置'));
						$this.setMarker(list);
					} else {
						// $this.$set($this.myLocation,"address",$this.searchKeyword);//自动设置地址
						$this.$emit('Update', $this.outPackData());
						$this.setTip(getLanguageStr('phrase545', '未搜索到符合的结果，请在地图中手动点击确定电站位置'));
					}
				});
				break;
			case 'googleMap':
				// let surl = `https://maps.google.cn/maps/api/geocode/json?key=${stage.loc.key.google}&address=`;
				let surl = `https://maps.googleapis.com/maps/api/geocode/json?key=${stage.loc.key.google}&address=`;
				axios.get(surl + text).then(data => {
					if ($this.useFor == 'new') $this.$set($this.myLocation, 'address', $this.searchKeyword);// 自动设置地址
					else if ($this.useFor == 'draw') {
						$this.name = $this.searchKeyword;
					}
					if (data.data.status == 'OK' && data.data.results.length > 0) { // 查询结果
						let list = [];
						data.data.results.forEach(item => {
							list.push({
								lng: item.geometry.location.lng,
								lat: item.geometry.location.lat,
								title: item.formatted_address
							});
						});
						if (data.data.results.length == 1) {
							$this.setPositionLv(data.data.results[0].geometry.location.lng, data.data.results[0].geometry.location.lat);
						} else $this.setTip(getLanguageStr('phrase544', '搜索到多个符合的结果，请在地图中选择一个作为电站位置'));
						//  console.log(list)
						$this.setMarker(list, true);
					} else {
						$this.$emit('Update', $this.outPackData());
						$this.setTip(getLanguageStr('phrase545', '未搜索到符合的结果，请在地图中手动点击确定电站位置'));
					}
				}).catch(error => { });
				break;
			}
		},
		backToSearch: function () {
			this.drawStatus = 0;
			this.clearMap();
			this.plantName = '';
			this.$emit('Update', this.outPackData());
		},
		getAutoLocation: function () { // 获取用户定位
			let $this = this;
			switch (this.map.active) {
			case 'amap':
				if (this.map.amap) {
					if (this.map.amap.autoLocation) this.map.amap.autoLocation.getCurrentPosition();
					else {
						setTimeout(function () { // 有时候就是还没准备好
							$this.map.amap.autoLocation.getCurrentPosition();
						}, 500);
					}
				}
				// if(this.map.amap) this.map.amap.toolBar.doLocation();
				break;
			case 'googleMap':
				// 默认情况，goole先定位，以免浏览器禁用定位导致无法定位问题
				if (this.map.googleMap.autoLocation) {
					this.map.googleMap.autoLocation.getCurrentPosition(p => {
						// trace(p, true)
						let data = {
							position: {
								P: p.coords.longitude,
								O: p.coords.latitude
							}
						};
						$this.autoLocationSuccess(data);
					}, error => {
						trace(error);
						$this.autoLocationError();
					}, {timeout: 1000 * 5});
				} else {
					$this.autoLocationError();
					break;
				}
				break;
			case '':
				break;
			}
		},
		autoLocationSuccess: function (data) {
			// trace(data,true)
			this.map.amap.setZoom(18);
			if (this.useFor == 'new') {
				if (this.myLocation.address == '') this.myLocation.address = data.formattedAddress;
			}
			this.setPositionLv(data.position.lng, data.position.lat);
			switch (this.useFor) {
			case 'new':
				this.setMarker([{lng: data.position.lng, lat: data.position.lat}], true);
				break;
			case 'draw':
				if (this.drawStatus === 0) this.setCenter(data.position.lng, data.position.lat);
			}
			// this.autoLocationError();
		},
		autoLocationError: function (data) {
			// this.getPosition();
			this.setPositionLv(121.50222222222222, 31.23611111111111);
			this.setMarker([{lng: this.myLocation.lng, lat: this.myLocation.lat}], true);
			this.getGeocoder({lng: this.myLocation.lng, lat: this.myLocation.lat});
			this.$notify(getLanguageStr('creat_plant47', '获取不到位置，自动切换为默认位置'));
			// navigator.geolocation.getCurrentPosition(function(asd){
			// 	trace(asd,true)
			// });
		},
		getGeocoder: function (data) { // 查询经纬度,{lng:,lat:}
			if (this.drawStatus == 0) {
				let search, $this = this;
				let fn = function (address, data) {
					// trace(data,true)
					switch ($this.useFor) {
					case 'new':
						// if($this.myLocation.address!=""){
						// 	address="";
						// }
						break;
					case 'draw':
						// if($this.searchKeyword=="") $this.plantName=address;
						$this.plantName = $this.searchKeyword || address;
						address = data ? data.province + data.city + data.district + data.street + data.streetNumber : '';
						break;
					}
					if (address) {
						$this.myLocation.address = address;
						$this.setPositionLv($this.myLocation.lng, $this.myLocation.lat);
					}
				};
				switch (this.map.active) {
				case 'amap':
					// if(AMap.Geocoder){//有时候居然会没有
					// 	search=new AMap.Geocoder();
					// 	if($.isPlainObject(data)){
					// 		search.getAddress(new AMap.LngLat(data.lng,data.lat),function(status,success){
					// 			// trace(success,true);
					// 			// address=success.regeocode.formattedAddress;
					// 			if(success.regeocode==undefined) $.extend(true,success,{regeocode:{formattedAddress:""}});
					// 			fn(success.regeocode.formattedAddress,success.regeocode.addressComponent);
					// 		});
					// 	}
					// }
					search = this.map.amap.geoCoder;
					if ($.isPlainObject(data)) {
						search.getAddress(new AMap.LngLat(data.lng, data.lat), function (status, success) {
							// trace(success,true);
							// address=success.regeocode.formattedAddress;
							if (success.regeocode == undefined) $.extend(true, success, {regeocode: {formattedAddress: ''}});
							fn(success.regeocode.formattedAddress, success.regeocode.addressComponent);
						});
					}
					break;
				case '':
					break;
				}
			}
		},
		mapClick: function () {
			switch (this.map.active) {
			case 'amap':
				if (this.drawStatus <= 1) this.setMarker([{lng: this.mouseLnglat[0], lat: this.mouseLnglat[1]}], true);

				switch (this.useFor) {
				case 'new':
					this.setPositionLv(this.mouseLnglat[0], this.mouseLnglat[1]);
					break;
				case 'draw':
					if (this.drawStatus == 0) { // 有绘制内容时不新加选点锚点
						this.setPositionLv(this.mouseLnglat[0], this.mouseLnglat[1]);
						this.getGeocoder({lng: this.mouseLnglat[0], lat: this.mouseLnglat[1]});
					}
					if (this.markerList.length > 2) {
						this.trackTip = getLanguageStr('phrase567', '点击起始点围合屋顶');
					} else if (this.markerList.length >= 0) {
						this.trackTip = getLanguageStr('phrase565', '点击地图继续绘制图形');
					}
					if (this.drawStatus === 1) this.updateArea();
					break;
				}
				break;
			}
		},
		config: function () { // 设置地图
			// $(this.$el).find(".map").on("mousedown",function(){//调试
			// 	trace(this)
			// });
			let $this = this;
			let map, autoLocation;
			switch (this.map.active) {
			case 'amap':
				map = this.map.amap;
				map.plugin('AMap.ToolBar', function () {
					let toolBar = new AMap.ToolBar({
						position: 'RB',
						offset: new AMap.Pixel(4, 85),
						ruler: false,
						locate: false,
						noIpLocate: true,
						direction: false,
						liteStyle: true
						// autoPosition:true
					});
					map.addControl(toolBar);
					map.toolBar = toolBar;// 保存下自动获取定位
					// AMap.event.addListener(toolBar,'location',$this.autoLocationSuccess);//注册自动定位成功事件
				});
				map.plugin('AMap.Geolocation', function () { // 注册查询插件
					autoLocation = new AMap.Geolocation({
						timeout: 1000 * 10, // 超过n秒后停止定位
						showButton: false,
						buttonPosition: 'RB',
						buttonOffset: new AMap.Pixel(8, 128),
						showMarker: false,
						showCircle: false
					});
					// if ($this.useFor == 'new') {
					map.addControl(autoLocation);
					// }
					AMap.event.addListener(autoLocation, 'complete', $this.autoLocationSuccess);// 注册自动定位成功事件
					AMap.event.addListener(autoLocation, 'error', $this.autoLocationError);// 注册自动定位成功事件
					map.autoLocation = autoLocation;// 保存下自动获取定位
				});
				map.plugin('AMap.Geocoder', function () { // 放置地理编码插件
					map.geoCoder = new AMap.Geocoder();
				});
				map.on('click', (e) => { // 地图点击事件
					// trace(e.lnglat,true);
					// lnglat:{O:lng,P:lat,....}
					this.mapClick();
					// $this.setMarker([{lng:e.lnglat.lng,lat:e.lnglat.lat}]);

					// switch(this.useFor){
					// 	case "new":
					// 		$this.setPositionLv(e.lnglat.lng,e.lnglat.lat);
					// 		break;
					// 	case "draw":
					// 		$this.setPositionLv(e.lnglat.lng,e.lnglat.lat);
					// 		$this.getGeocoder({lng:e.lnglat.lng,e.lnglat.lat});
					// 		if(this.markerList.length>1){
					// 			this.trackTip=getLanguageStr("phrase567","点击起始点围合屋顶");
					// 		}
					// 		else if(this.markerList.length>=0){
					// 			this.trackTip=getLanguageStr("phrase565","点击地图继续绘制图形");
					// 		}
					// 		if(this.drawing) this.updateArea(e.lnglat);
					// 		break;
					// }
				});
				map.on('mousemove', (e) => {
					this.mouseLnglat = [e.lnglat.lng, e.lnglat.lat];
					if (this.drawStatus === 1 && this.markerList.length > 0) { // 绘制点的跟踪线
						this.updateLine();
					}
				});
				let autoComplete = new AMap.Autocomplete({// 输入自动完成
					input: $(this.$el).find("[type='text']")[0]
				});
				AMap.event.addListener(autoComplete, 'select', this.selectAutoComplete);// 添加自动填充功能
				map.searchInput = new AMap.PlaceSearch({
					// map:map
				});// 构造地点查询类
				break;
			case 'googleMap':
				map = this.map.googleMap;
				autoLocation = navigator.geolocation;
				map.autoLocation = autoLocation;// 保存下自动获取定位
				google.maps.event.addListener(this.map.googleMap, 'click', event => {
					this.clearMarker();
					// this.map.googleMap.setCenter(event.latLng)
					// let marker = new google.maps.Marker({
					// 	position: event.latLng,
					// 	icon: '/static/image/map/markerAct.png',
					// 	animation: google.maps.Animation.DROP,
					// 	map: this.map.googleMap
					// })
					// this.googleMapMaker.push(marker)
					// this.map.googleMap.setZoom(14)
					// $this.getPosition()
					setTimeout(() => {
						// console.log(event.latLng.lng(), event.latLng.lat())
						this.setPositionLv(event.latLng.lng(), event.latLng.lat());
						this.setMarker([{lng: event.latLng.lng(), lat: event.latLng.lat()}], true);
					}, 0);

					// alert(1)
				});
				// 解决com地址被墙问题，替换成cn的地址
				function updateMapImg () {
					// setTimeout(()=>{
					// 	$.each($($this.$el).find(".map .gm-style img"),function(){
					// 		let src=$(this).attr("src");
					// 		if(src.indexOf(".google.com")){
					// 			src.replace(/mts[0-9]{1}.google.com/,"maps.google.cn");
					// 			$(this).attr("src",src);
					// 			// trace($(this).attr("src"))
					// 		}
					// 	});
					// },100);
				}
				this.map.googleMap.addListener('drag', updateMapImg);
				this.map.googleMap.addListener('zoom_changed', updateMapImg);
				//					var autocomplete = new google.maps.places.Autocomplete(document.getElementById('autoCompleteSearch'));
				//					autocomplete.bindTo('bounds', map);
				//					autocomplete.setFields(['address_components', 'geometry', 'icon', 'name']);
				//					autocomplete.addListener('place_changed', function() {
				//			          var place = autocomplete.getPlace();
				//			          console.log(11111)
				//			          if (!place.geometry) {
				//			            // User entered the name of a Place that was not suggested and
				//			            // pressed the Enter key, or the Place Details request failed.
				//			            window.alert("No details available for input: '" + place.name + "'");
				//			            return;
				//			          }
				//					  console.log(place)
				//			        });
				break;
			}
		},
		doSatellite: function () { // 切换卫星图
			switch (this.satellite.status) {
			case false:
				// $(this).removeClass("f-sub").addClass("f-main");
				switch (this.map.active) {
				case 'amap':
					this.satellite.amap.setMap(this.map.amap);
					break;
				case 'googleMap':
					this.map.googleMap.setMapTypeId('hybrid');
					break;
				}
				this.satellite.status = true;
				break;
			case true:
				// $(this).removeClass("f-main").addClass("f-sub");
				switch (this.map.active) {
				case 'amap':
					this.satellite.amap.setMap(null);
					break;
				case 'googleMap':
					this.map.googleMap.setMapTypeId('roadmap');
					break;
				}
				this.satellite.status = false;
				break;
			}
		},
		setPositionLv: function (lng, lat) { // 设置经纬度，同时转化成时间
			if (this.drawStatus == 0) {
				if (lng && lat) {
					this.myLocation.lng = lng;
					this.myLocation.lat = lat;
				}
				let lngArr = this.lngLatToTime(this.myLocation.lng);

				let latArr = this.lngLatToTime(this.myLocation.lat);
				this.myLocation.lngLv.lv1 = lngArr[0];
				this.myLocation.lngLv.lv2 = lngArr[1];
				this.myLocation.lngLv.lv3 = lngArr[2];
				this.myLocation.latLv.lv1 = latArr[0];
				this.myLocation.latLv.lv2 = latArr[1];
				this.myLocation.latLv.lv3 = latArr[2];

				this.$emit('Update', this.outPackData());
			}
		},
		clearMarker: function () { // 清空marker
			let map = this.map[this.map.active];
			if (map) {
				switch (this.map.active) {
				case 'amap':
					// this.map[this.map.active].remove(this.markerList);
					map.clearMap();
					break;

				case 'googleMap':
					this.googleMapMaker.map(maker => {
						maker.setMap(null);
					});
					this.googleMapMaker = [];
					break;
				}
			}
			this.markerList = [];
		},
		setCenter: function (lng, lat) { // 设置地图中心点并最大化显示
			if (!lng) {
				lng = this.addressCode.lv1.list.length ? this.addressCode.lv1.list[0].longitude : null;
			}
			if (!lat) {
				lat = this.addressCode.lv1.list[0].latitude || null;
			}
			switch (this.map.active) {
			case 'amap':
				this.map.amap.setCenter(new AMap.LngLat(lng || this.option.amap.center.lng, lat || this.option.amap.center.lat));// setZoomAndCenter(lng?18:4),
				break;
			case 'googleMap':
				this.map.googleMap.setCenter(new google.maps.LatLng(lat || this.option.googleMap.center.lat, lng || this.option.googleMap.center.lng));
				break;
			}
		},
		setMarker: function (list, userAction = false) { // 可批量设置点标记
			if (this.drawStatus < 1) this.clearMarker();
			let i = 1, tLng = 0, tLat = 0;
			if (list) {
				let $this = this, endFn = null;
				$.each(list, function (index) {
					let marker = null;

					switch ($this.map.active) {
					case 'amap':
						if ($this.drawStatus == 0) {
							marker = new AMap.Marker({
								// map:$this.map.amap,
								title: this.title || '',
								position: [this.lng, this.lat],
								icon: new AMap.Icon({
									image: '/static/image/map/marker' + (list.length == 1 ? 'Act' : 'Def') + '.png',
									size: new AMap.Size(40, 46)
									// imageOffset:new AMap.Pixel()
								}),
								offset: new AMap.Pixel(-13, -45),
								animation: 'AMAP_ANIMATION_DROP',
								index: index,
								extData: {
									index: index
								}
							});
							if (list.length > 1) { // 多个备选情况才有点击事件
								marker.on('click', function (e) { // marker点击事件
									// trace(e,true);
									if ($this.myLocation.address == '') $this.$set($this.myLocation, 'address', $this.searchKeyword);// 自动设置地址

									let target = $this.markerList[e.target.getExtData().index].getPosition(userAction);
									$this.setPositionLv(target.lng, target.lat);
									$this.setMarker([{lng: target.lng, lat: target.lat}], true);
									// if($this.useFor=="draw"&&$this.drawStatus===0){
									$this.getGeocoder($this.myLocation);
									// }
								});
							} else if (userAction) {
								$this.setPositionLv(this.lng, this.lat);
								$this.getPosition(userAction);
							}
							endFn = function () {
								$this.fitView();
							};
						} else if ($this.drawStatus >= 1) { // 绘制模式
							marker = new AMap.Marker({
								position: [this.lng, this.lat],
								// icon:new AMap.Icon({
								// 	image:"/static/image/map/marker"+(list.length==1? "Act":"Def")+".png",
								// 	size:new AMap.Size(40,46),
								// 	// imageOffset:new AMap.Pixel()
								// }),
								content: `
										<svg class="w1x h1x fRed"><use xlink:href="#mapAreaPoint"></use></svg>
									`,
								offset: new AMap.Pixel(-parseInt($('html').css('font-size')) / 2, -parseInt($('html').css('font-size')) / 2),
								draggable: $this.drawStatus === 1,
								index: $this.markerList.length
								// offset:new AMap.Pixel(-11,-45),
							});
							// marker=new AMap.CircleMarker({
							// 	// map:$this.map.amap,
							// 	center:[this.lng,this.lat],
							// 	radius:5,
							// 	strokeColor:"#fff",
							// 	strokeOpacity:1,
							// 	strokeWeight:1.5,
							// 	fillColor:stage.color.red,
							// 	fillOpacity:1,
							// 	draggable:true
							// });
							marker.on('click', (e) => {
								// trace(e,true)
								$this.endDraw(e.target.F.index);
							});
							AMap.event.addListener(marker, 'dragging', (e) => {
								$this.mouseLnglat = [e.lnglat.lng, e.lnglat.lat];
								$this.updateArea();
								// if($this.drawing){//绘制时才能拖动
								// }
							});
						}
						if (marker) {
							$this.nsChange();
							marker.setMap($this.map.amap);
							$this.markerList.push(marker);
							if ($this.markerList.length >= 30) $this.endDraw();
						}
						break;
					case 'googleMap':
						if ($this.drawStatus == 0) {
							let lnglat = new google.maps.LatLng(this.lat, this.lng);
							//							if($this.googleMapMaker!=null)$this.googleMapMaker.setMap(null);

							var gMarker = new google.maps.Marker({
								position: lnglat,
								icon: '/static/image/map/marker' + (list.length == 1 ? 'Act' : 'Def') + '.png',
								animation: google.maps.Animation.DROP,
								map: $this.map.googleMap
							});
							$this.googleMapMaker.push(gMarker);
							if (list.length > 1) {
								gMarker.addListener('click', function () {
									$this.setPositionLv(gMarker.position.lng(), gMarker.position.lat());
									$this.setMarker([{lng: gMarker.position.lng(), lat: gMarker.position.lat()}], true);
									$this.getGeocoder($this.myLocation);
								});
							}
							if (i == list.length) {
								// tLng = (tLng + this.lng) / list.length
								// tLat = (tLat + this.lat) / list.length
								// let mapcenter = new google.maps.LatLng(,);

								// setTimeout(()=>{
								$this.setCenter(this.lng, this.lat);
								$this.map.googleMap.setZoom(14);
								// },0);
								// $this.map.googleMap.setCenter(mapcenter)

								if (userAction) {
									$this.setPositionLv(this.lng, this.lat);
									$this.getPosition(userAction);
								}
							}
							// else {
							// 	tLng += this.lng
							// 	tLat += this.lat
							// 	i++
							// 	// console.log(userAction)
							// 	$this.getPosition(userAction)
							// }
						}
						break;
					}
				});
				if (endFn) endFn();
			}
		},
		fitView: function () { // 根据marker分布，刷新合适的视图
			switch (this.map.active) {
			case 'amap':
				this.map.amap.setFitView();
				break;
			case 'googleMap':
				this.map.googleMap.setZoom(14);
				break;
				// case "":
				// 	break;
			}
		},
		doVerification: function () { // 检测输入格式
			let allClear = true;
			$.each(this.$refs, function () {
				if (this.verification) {
					let clear = this.doVerification();
					if (allClear) allClear = clear;
				}
				// if(allClear==false) return false;
			});
			// if(this.address=="") clear=false;
			return allClear;
		},
		timeToLngLat: function (data) { // 经纬度度分秒转换为小数
			// public double convertToDecimal(double du, double fen, double miao) {
			if (data.lv1 < 0) return -(Math.abs(data.lv1) + (Math.abs(data.lv2) + (Math.abs(data.lv3) / 60)) / 60);
			else return Math.abs(data.lv1) + (Math.abs(data.lv2) + (Math.abs(data.lv3) / 60)) / 60;
			// }
		},
		lngLatToTime: function (data) { // 经纬度转换为时间
			if ($.isNumeric(data)) {
				let arr = new Array(3);
				arr[0] = parseInt(data);
				// arr[1]=floatFix((data-arr[0])*60,0);
				// arr[2]=floatFix( ((data-arr[0])*60-Math.floor((data-arr[0])*60))*60,2);
				arr[1] = floatFix((Math.abs(data - arr[0])) * 60, 0, null, false);
				arr[2] = floatFix(((Math.abs(data - arr[0])) * 60 - parseInt((Math.abs(data - arr[0])) * 60)) * 60, 2);
				return arr;
			}
		},
		blur: function () {
			if (this.myLocation.lngLv.lv1 !== '' && this.myLocation.lngLv.lv2 !== '' && this.myLocation.lngLv.lv3 !== '' &&
				this.myLocation.latLv.lv1 !== '' && this.myLocation.latLv.lv2 !== '' && this.myLocation.latLv.lv3 !== '') {
				this.myLocation.lng = this.timeToLngLat(this.myLocation.lngLv);
				this.myLocation.lat = this.timeToLngLat(this.myLocation.latLv);
				this.setMarker([{lng: this.myLocation.lng, lat: this.myLocation.lat}], true);
				// this.getPosition();
			}
		},
		getPosition (userAction = false) {
			if (this.myLocation.lngLv.lv1 !== '' && this.myLocation.lngLv.lv2 !== '' && this.myLocation.lngLv.lv3 !== '' &&
				this.myLocation.latLv.lv1 !== '' && this.myLocation.latLv.lv2 !== '' && this.myLocation.latLv.lv3 !== '') {
				let $this = this;
				searchAreaDetailsByLatlon({
					longitude: this.myLocation.lng,
					latitude: this.myLocation.lat
				}).then(function (success) {
					let result = _.cloneDeep(success);
					const posCountryCode = result[result.length - 1].code;
					const find = objTool($this.addressCode.lv1.list, 'findByKey', ['code', posCountryCode]);
					if (find[1]) {
						// 查找国家是否已在可选范围内
					} else {
						// message.message('error', getLanguageStr('create_plant_area_tips', '因政策法规限制，当前应用暂不支持在该区域建站！'));
						// $this.myLocation.lng = $this.myLocation.lat = $this.myLocation.address = '';
						// $this.clearMarker();
						// $this.$emit('Update', $this.outPackData());
						// return;
					}
					// Object.keys($this.addressCode).forEach(key => {
					//   $this.addressCode[key].id = ''
					//   $this.addressCode[key].list = []

					// })

					if (result && result.length == 0) {
						$this.initAreaList();
					} else if (result) {
						result.sort(function (m, n) {
							if (m.level < n.level) return -1;
							else if (m.level > n.level) return 1;
							else return 0;
						});
						// console.log(result)
						$this.nowlength = result.length;
						if (result.length < 6) {
							let rl = result.length;
							// console.log(rl)
							for (rl; rl <= 6; rl++) {
								$this.addressCode['lv' + rl] = {list: []};
							}
						}
						// trace($this.addressCode, false, true)
						result = result.map((v, i) => {
							if (v.id != $this.addressCode['lv' + (i + 1)].id) {
								let adc = {...v};
								if (v.parentId != $this.addressCode['lv' + (i + 1)].parentId) adc.list = [];
								else adc.list = $this.addressCode['lv' + (i + 1)].list;
								$this.addressCode['lv' + (i + 1)] = {...adc};
								// console.log({...adc})
							}
							//							$this.addressCode['lv'+(i+1)] = {...v,...$this.addressCode['lv'+(i+1)]};
						});
						$this.initAreaList();
					}

					//					if(success){
					//						// if($this.map[$this.map.active]) $this.setMarker([$this.myLocation]);//加载完地图才设置标记
					//						$this.addressCode.lv1=success.level1||{id:""};
					//						$this.addressCode.lv2=success.level2||{id:""};
					//						$this.addressCode.lv3=success.level3||{id:""};
					//						$this.addressCode.lv4=success.level4||{id:""};
					//						// $this.data.station.location.address=success.level1.name+""+success.level2.name+""+success.level3.name+""+success.level4.name+"";
					//					}else{
					//						$this.addressCode.lv1={id:""},
					//						$this.addressCode.lv2={id:""},
					//						$this.addressCode.lv3={id:""},
					//						$this.addressCode.lv4={id:""},
					//						// $.extend(true,$this.myLocation,{
					//						// 	lngLv:{lv1:"",lv2:"",lv3:"",lv4:""},
					//						// 	latLv:{lv1:"",lv2:"",lv3:"",lv4:""}
					//						// });
					//						// $this.lock.newPlant=false;
					//						//alert(getLanguageStr("phrase541","无效的经纬度地址，请重新输入"));
					//						// $this.$notify(getLanguageStr("phrase547","此经纬度无法匹配合适的地址信息"))
					//						$this.$notify(getLanguageStr("phrase541","无效的经纬度地址，请重新输入"))
					//					}
					$this.$emit('Update', $this.outPackData(), userAction);
				}, function (error) {
					$this.lock.newPlant = false;
					// alert(error);
					$this.addressCode.lv1 = {id: '', parentId: 0, list: []},
					$this.addressCode.lv2 = {id: '', list: []},
					$this.addressCode.lv3 = {id: '', list: []},
					$this.addressCode.lv4 = {id: '', list: []},
					$this.addressCode.lv5 = {id: '', list: []},
					$this.addressCode.lv6 = {id: '', list: []},
					$this.initAreaList();
					$.extend(true, $this.myLocation, {
						lngLv: {lv1: '', lv2: '', lv3: '', lv4: '', lv5: '', lv6: ''},
						latLv: {lv1: '', lv2: '', lv3: '', lv4: '', lv5: '', lv6: ''}
					});

					$this.$emit('Update', $this.outPackData());
					$this.$notify(getLanguageStr('phrase541', '无效的经纬度地址，请重新输入'));
					!_.isEmpty(error) && $this.$notify(error);
				});
			}
		},
		initAreaList () {
			// console.log(this.addressCode.lv1.id)
			if (!this.addressCode.lv1.id && this.defaultRegion.nationId) { // 仅初始化的时候
				this.addressCode.lv1.id = this.defaultRegion.nationId;
				this.addressCode.lv2.id = this.addressCode.lv2.id || this.defaultRegion.level1;
				this.addressCode.lv3.id = this.addressCode.lv3.id || this.defaultRegion.level2;
				this.addressCode.lv4.id = this.addressCode.lv4.id || this.defaultRegion.level3;
				this.addressCode.lv5.id = this.addressCode.lv5.id || this.defaultRegion.level4;
				this.addressCode.lv6.id = this.addressCode.lv6.id || this.defaultRegion.level5;
			}
			if (this.nowlength < 6) {
				let rl = this.nowlength + 1;
				for (rl; rl <= 6; rl++) {
					this.addressCode['lv' + rl] = {id: '', list: []};
				}
			}
			//			if(this.addressCode.lv1.list.length==0){
			Object.keys(this.addressCode).forEach((k, i) => {
				if (this.addressCode[k].parentId >= 0) {
					searchAreaList(this.addressCode[k].parentId).then(res => {
						this.addressCode[k].list = res;
						// if(k=="lv1"&&this.isEdit==false){//如果是新建场景，拿到国家数据后，默认下是第一个
						// 	this.setCenter(this.addressCode[k].list[1].longitude,this.addressCode[k].list[1].latitude);
						// }
					}, error => { });
				} else if (i > 0 && i < 6 && this.addressCode['lv' + i].id) { // 上一层已经选择了,初始化出下一层
					searchAreaList(this.addressCode['lv' + i].id).then(res => {
						let selectToken = {
							name: getLanguageStr('cmd19', '全部'), id: null, def: ''
						};
						if (this.addressCode.lv1.id == 44) { // 中国的场景
							switch (i) {
							case 1:selectToken.def = getLanguageStr('manage221', '省'); break;
							case 2:selectToken.def = getLanguageStr('manage222', '市'); break;
							case 3:selectToken.def = getLanguageStr('plant_detail273', '区'); break;
								// case 4:selectToken.def=getLanguageStr('','县');break;
							}
						} else { // 非中国 的场景
							selectToken.def = i18n.t('fill3rd156', [i, '级区域']);
						}
						if (res && res.length) this.addressCode[k].list = [selectToken].concat(res);
					}, error => { });
				} else {
					this.addressCode[k].list = [];
				}
			});
			//			}
		},
		initSubAreaList (pid, k, first, userAction) {
			let $this = this;
			searchAreaList(pid).then(res => {
				this.addressCode[k].list = [first].concat(res);
				if (this.isEdit == false) $this.$emit('Update', $this.outPackData(), userAction);
			}, error => { });
		},
		mapLoaded: function () { // 地图加载后执行
			let $this = this;
			switch ($this.map.active) {
			case 'amap':
				if (typeof (AMap) === 'undefined') {
					$this.setMap();
				} else if (!this.map.amap) {
					$this.lib.amap = AMap;
					$this.map.amap = new AMap.Map($(this.$el).find('.' + $this.map.active)[0], $.extend(true, $this.option.amap, {
						// center: [107.490234375, 35.10193405724606],
						// layers:this.useFor=="draw"? [new AMap.TileLayer.Satellite(),new AMap.TileLayer.RoadNet()]:[]
						// layers: [new AMap.TileLayer.Satellite(), new AMap.TileLayer.RoadNet()]
					}));
					$this.config();
					this.satellite.amap = new AMap.TileLayer.Satellite({
						// map:map,
						zIndex: 1
					});
					if (this.useFor == 'new' && $this.myLocation.lng && $this.myLocation.lat) {
						// $this.setMarker([{lng:$this.myLocation.lng,lat:$this.myLocation.lat}]);
					}
					// else $this.getAutoLocation();//没有经纬度，自动获取
					// if(!mapData) mapData=[];//数据未加载好
					// else{
					// 	load_map(mapData,$("[useMap]").attr("id"),mapOptionNew);
					// 	dataStatusChange($("#mapObj>[dataStatus]"),"true");
					// }
				} else {
					if (this.useFor == 'new') {
						this.map.amap.setZoom(4);
					}
				}
				break;
			case 'googleMap':
				$this.lib.googleMap = google;
				this.map.googleMap = new google.maps.Map($(this.$el).find('.' + $this.map.active)[0], $.extend(true, {}, this.option.googleMap, {
					// mapTypeId: google.maps.MapTypeId.HYBRID
					// mapTypeControlOptions:{
					// 	position: google.maps.ControlPosition.RIGHT_TOP
					// }
				}));
				$this.config();
				// this.map.googleMap.setZoom(14)
				break;
			}
			if (this.useFor == 'new') {
				/** ***编辑时候不需要解析IP****************/
				if (!this.location.lat || !this.location.lng) {
					this.getCountryCode();
				} else if (this.defaultRegion.nationId) {
					this.addressCode.lv1.id = this.defaultRegion.nationId;
					this.addressCode.lv2.id = this.defaultRegion.level1;
					this.addressCode.lv3.id = this.defaultRegion.level2;
					this.addressCode.lv4.id = this.defaultRegion.level3;
					this.addressCode.lv5.id = this.defaultRegion.level4;
					this.addressCode.lv6.id = this.defaultRegion.level5;
				} else {
					this.getCountryCode();
				}
				if (this.myLocation.lng) {
					setTimeout(() => {
						$this.setMarker([{lng: this.myLocation.lng, lat: this.myLocation.lat}]);
					}, 0);
				} else {
					this.clearMarker();
					setTimeout(() => {
						this.setCenter();
					}, 0);
					// this.getAutoLocation();
				}
				if (this.isEdit) { // 编辑模式
					// this.getPosition();
					this.initAreaList();
				}
			} else if (this.useFor == 'draw') {
				if (this.myAreaPoint) { // 如果已经有范围数据，直接绘制区域
					this.drawStatus = 3;
					this.setMarker(this.myAreaPoint);
					this.buildArea();
					this.updateArea();
					this.fitView();
					this.$emit('Update', this.outPackData());
				} else {
					this.getAutoLocation();
					this.setTip(getLanguageStr('phrase559', '请搜索电站地址或在地图上直接点选开始评估！'));
				}
			} else if (this.useFor == 'showArea') {
				this.clearMap();
				this.drawStatus = 3;
				this.setMarker(this.myAreaPoint);
				this.buildArea();
				this.updateArea();
				this.fitView();
			}
			this.$refs.Loading.hide();
			// setTimeout(()=>{//部分服务异步到位
			// },100*5);
		},
		getCountryCode () {
			let $this = this;
			apiGetCountry().then(success => {
				let lv1Info = objTool($this.addressCode.lv1.list, 'findByKey', ['code', success.code]);// [index,value]
				// success = 'US'
				// $this.addressCode.lv1.list.map(item => {
				// 	if (item.code == success) lv1Info = item
				// });
				$this.addressCode.lv1 = {...$this.addressCode.lv1, ...lv1Info[1]};
				$this.addressChangeFit(1);// 自动切换到该国家的视图
				$this.initSubAreaList($this.addressCode.lv1.id, 'lv2', {name: getLanguageStr('cmd19', '全部'), id: null, def: lv1Info[1].code == 'CN' ? getLanguageStr('word676', '省') : i18n.t('fill3rd156', [1, '级区域'])}, true);
			}, error => {
				// this.$notify(error)
			});
		},
		setMap: function () {
			let $this = this;
			function getCountryNext (success) {
				$this.map.country = success;
				// let lv1Info = {}
				// $this.addressCode.lv1.list.map(item => {
				// 	if (item.code == success) lv1Info = item
				// });
				// 如果获取不到ip，取第一个数据作为默认值
				// if($.isEmptyObject(lv1Info)) lv1Info=$this.addressCode.lv1.list[0];
				if (!$this.addressCode.lv1.id && !success && $this.addressCode.lv1.list.length) {
					$this.addressCode.lv1.id = $this.addressCode.lv1.list[0].id;
				} else if (success && $this.addressCode.lv1.list.length) {
					let finded = objTool($this.addressCode.lv1.list, 'findByKey', ['code', success])[1];
					if (finded) {
						$this.addressCode.lv1.id = $this.defaultRegion.nationId = finded.id;
					} else { // 没有找到该国家
						$this.addressCode.lv1.id = $this.addressCode.lv1.list[0].id;
					}
				}

				$this.initSubAreaList(
					$this.addressCode.lv1.id,
					'lv2', {
						name: getLanguageStr('cmd19', '全部'),
						id: null,
						def: (
							$this.addressCode.lv1.id == 44 ? getLanguageStr('word676', '省') : i18n.t('fill3rd156', [1, '级区域'])
						)
					}
				);
				if (success == 'CN' || (!success && stage.languageId == 'zh')) {
					// if(this.map.active==""){
					// if(this.map.country=="CN")
					$this.map.active = 'amap';
					// }
				} else $this.map.active = 'googleMap';
				// $this.map.active="googleMap";//调试

				$this.$refs.Loading.show();
				// let script = '';
				switch ($this.map.active) {
				case 'amap':
					if (typeof (AMap) === 'undefined') { // 还未加载高德地图
						window.mapApiLoadedForCreatPlant = $this.mapLoaded;
						$.getScript(`https://webapi.amap.com/maps?v=1.4.15&key=${stage.loc.key.amap}&plugin=AMap.Autocomplete,AMap.DistrictLayer,AMap.StyleObject,AMap.PlaceSearch,AMap.MarkerClusterer&callback=mapApiLoadedForCreatPlant`);//, this.mapLoaded
						// script=document.createElement('script');
						// script.src="https://webapi.amap.com/maps?v=1.4.8&key=19cacba68756210399cfed0012e65e05&plugin=AMap.Autocomplete,AMap.PlaceSearch";//&callback=onApiLoaded
						// script.onload=script.onreadystatechange=function(){
						// 	if(!this.readyState||this.readyState=='loaded'||this.readyState=='complete'){
						// 		// setTimeout();
						// 		trace(this.readyState);$this.mapLoaded();
						// 	}
						// 	// script.onload=script.onreadystatechange=null;
						// }
						// document.head.appendChild(script);
					} else { // 可能已有AMap
						$this.mapLoaded();
					}
					break;
				case 'googleMap':
					if (window.google && window.google.maps) {
						$this.mapLoaded();
						if ($this.isEdit == false) {
							// $this.addressChangeFit(1);
							$this.setCenter();
						}
					} else {
						window.mapApiLoadedForCreatPlant = $this.mapLoaded;
						let mapS = `https://maps.googleapis.com/maps/api/js?key=${stage.loc.key.google}&callback=mapApiLoadedForCreatPlant&libraries=places,geometry&language=${stage.languageId}&region=${$this.map.country}`;
						// let mapS = `//maps.google.cn/maps/api/js?key=${stage.loc.key.google}&libraries=places,geometry&callback=mapApiLoadedForCreatPlant&language=${stage.languageId}&region=${$this.map.country}`;
						$.ajax(mapS, {
							dataType: 'script',
							success: function (data) {
								// trace(data,true);
							}
						});
					}
					break;
				}
			}
			apiGetCountry().then(success => {
				let delayRun;
				if (this.addressCode.lv1.id) getCountryNext(success.code);
				else {
					delayRun = setTimeout(() => { // 后续动作依赖于国家列表，暂时轮询等待再做下一步动作setInterval
						// if(this.addressCode.lv1.id) clearInterval(delayRun);
						getCountryNext(success.code);
					}, 1000);
				}
			}, error => {
				// this.$notify(error)
			});
		},
		clearMap: function () {
			this.clearMarker();
			switch (this.map.active) {
			case 'amap':
				// this.clearMarker();
				if (this.map.amap) this.map.amap.clearMap();
				break;
			case 'googleMap':
				break;
			}
		},
		buildArea: function () { // 创建多边形
			switch (this.map.active) {
			case 'amap':
				this.area = new AMap.Polygon({
					map: this.map[this.map.active],
					// path:[[120.36095787271853,31.506799532389856],[120.36099542364474,31.506495388452244],[120.36202539190651,31.50648624125082]],
					// strokeColor:stage.color.red,
					strokeOpacity: 0,
					// strokeWeight:2,
					fillColor: stage.color.red,
					fillOpacity: 0.3
				});
				this.line = new AMap.Polyline({
					map: this.map[this.map.active],
					strokeColor: stage.color.redDark,
					strokeOpacity: 1,
					strokeWeight: 2,
					draggable: false
				});
				AMap.event.addListener(this.line, 'click', () => {
					this.mapClick();
				});
				break;
			}
			// this.area.setMap(this.map[this.map.active]);
		},
		updateArea: function () { // 更新多边形数据
			switch (this.map.active) {
			case 'amap':
				let areaPath = [];
				$(this.markerList).each(function () {
					let lng = this.lng || this.getPosition().lng;
					let lat = this.lat || this.getPosition().lat;
					areaPath.push([lng, lat]);
				});
				this.area.setPath(areaPath);
				this.areaData = this.area.getArea();// 获取面积
				this.updateLine();
				break;
			}
		},
		updateLine: function () {
			switch (this.map.active) {
			case 'amap':
				let linePath = [];
				$(this.markerList).each(function () {
					let lng = this.lng || this.getPosition().lng;
					let lat = this.lat || this.getPosition().lat;
					linePath.push([lng, lat]);
				});
				if (this.drawStatus === 1) { // 绘制的时候追加鼠标坐标
					linePath.push(this.mouseLnglat);
				} else if (this.drawStatus >= 2) linePath.push([linePath[0][0], linePath[0][1]]);// 结束的时候添加起始点
				this.line.setPath(linePath);
				break;
			}
		},
		startDraw: function () {
			this.clearMap();
			this.drawStatus = 1;
			if (this.drawStatus === 1) {
				this.trackTip = getLanguageStr('phrase566', '点击地图开始绘制图形');
				this.buildArea();
			}
		},
		reDraw: function (confirm = false) {
			let $this = this;
			function yes () {
				$this.clearMap();
				$this.drawStatus = 1;
				$this.trackTip = getLanguageStr('phrase566', '点击地图开始绘制图形');
				$this.buildArea();
				$this.$emit('Update', $this.outPackData());
			}
			if (confirm == true) {
				this.$refs.Confirm.show({
					text: getLanguageStr('phrase612', '确定要删除屋顶吗？'),
					yes
				});
			} else yes();
		},
		endDraw: function (index = 0) { // 判断结束绘制
			if (this.drawStatus === 1 && this.markerList.length > 2 && index == 0) { // 绘制阶段满三个点、点击起点才可以围合
				this.drawStatus = 2;
				this.updateArea();
				if (this.areaData <= 100000) {
					$.each(this.markerList, function () {
						this.setDraggable(false);
					});

					if (this.useFor == 'new') {
						this.$emit('Update', this.outPackData());
					} else {
						this.$refs.loadingIRR.show();
						apiGetIrradiationData({lat: this.markerList[0].getPosition().lat, lon: this.markerList[0].getPosition().lng}).then(success => {
							// trace(success,true)
							// trace(success.features[0].properties.parameter.ALLSKY_SFC_SW_DWN)
							if (success && success.features) {
								this.OA = success.features[0].properties.parameter.ALLSKY_SFC_SW_DWN;
							} else {
								this.OA = {1: 0, 2: 0, 3: 0, 4: 0, 5: 0, 6: 0, 7: 0, 8: 0, 9: 0, 10: 0, 11: 0, 12: 0, 13: 0};
								trace('没有拿到辐照数据');
							}

							this.$refs.loadingIRR.hide();
							if (this.drawStatus == 2) { // 在别的阶段不作处理
								this.drawStatus = 3;
								// 获取IRR

								this.$emit('Update', this.outPackData());
							}
						}, error => {
							this.$notify(error);
						});
					}
				} else {
					this.reDraw();
					this.$notify(i18n.t('fill3rd118', [100000, '绘制面积不能超过㎡']));
				}
			}
		},
		show: function (data, delayMs = 0) { // 延时执行有利于户体验，动画过程中不会卡
			this.$refs.Loading.show();
			let $this = this, fn;
			this.reset(data);
			if (this.lib[this.map.active]) {
				fn = () => {
					this.$refs.Loading.hide();
					$this.mapLoaded();
				};
			} else {
				fn = () => {
					this.setMap();
				};
			}
			setTimeout(fn, delayMs);
		}
	},
	created () {
		// this.reset()
		// this.getPosition();
	},
	mounted () {
		if (this.useFor == 'draw') {
			$(this.$el).find('.map').css('height', $(window).height() - $(this.$el).parents('.body').first().children('.head').innerHeight());
		}
		// setScroll($("#"+this.id).find(".report [scroll]"));
		$(document).on('keyup', (key) => {
			// trace(key)
			if (this.drawStatus === 1 && key.key == 'Escape') {
				this.reDraw();
				// this.drawing=false;
			}
		});
		$(this.$el).find('.map').on('mouseenter', (e) => {
			$(this.$el).find('.trackTip').css('opacity', 1);
		});
		$(this.$el).find('.map').on('mouseleave', (e) => {
			$(this.$el).find('.trackTip').css('opacity', 0);
		});
		$(this.$el).find('.map').on('mousemove', (e) => {
			// trace(e,true)
			let baseSpace = parseInt($('html').css('font-size'));
			let antiX = e.pageX + baseSpace * 2 + $(this.$el).find('.trackTip').innerWidth() > $(window).width() ? -$(this.$el).find('.trackTip').innerWidth() - baseSpace * 2 : baseSpace * 2;
			let antiY = e.pageY - $(this.$el).offset().top + baseSpace + $(this.$el).find('.trackTip').innerHeight() > $(window).height() - $(this.$el).offset().top ? -$(this.$el).find('.trackTip').innerHeight() - baseSpace : baseSpace;
			$(this.$el).find('.trackTip').css({'left': e.pageX + antiX, 'top': e.pageY - $(this.$el).offset().top + antiY});
		});
		// $("#"+this.id+" .map").on("click",()=>{
		// 	this.mapClick();
		// });

		if (this.useFor == 'showArea') {
			this.show();
		}

		// test

		// window.mapApiLoadedForCreatPlant=function(){
		// 	new AMap.Map($("#asd")[0]);
		// }
		// $.getScript("https://webapi.amap.com/maps?v=1.4.8&key=19cacba68756210399cfed0012e65e05&plugin=AMap.Autocomplete,AMap.PlaceSearch&callback=mapApiLoadedForCreatPlant");
	}
};
</script>
<style lang="scss" scoped>
//@import "~@/style/definition.scss";
.fa-map-marker {
	font-size: 3em;
}
.curCross {
	cursor: crosshair;
}
.search {
	position: absolute;
	top: 1em;
	left: 2em;
	z-index: 3;
	> * > * {
		@extend %boxShadowPublic;
	}
}

.trackTip {
	padding: 0.5em 1em;
	position: absolute;
	z-index: 1;
	transition: 0.2s ease-out;
	@extend %boxShadowPublic;
}
.report {
	position: absolute;
	top: 4.5em;
	left: 2em;
	z-index: 2;
	@extend %boxShadowPublic;
}

.mapBox{position:relative;
	.toolbar{position:absolute;}
	.map {z-index:1;
		}
	.tip {
		width: 100%;
		position: absolute;
		top: 30em - 2;
		left: 0;
		z-index: 1;
		pointer-events: none;
		.text {
			display: inline-block;
			padding: {
				top: 0.5em;
				bottom: 0.5em;
				left: 1em;
				right: 1em;
			}
			font-size: 1.2em;
			opacity: 0;
			visibility: hidden;
			position: relative;
			top: 0;
			box-shadow: 0 1em 2em rgba(#000, 0.2);
		}
		&.open {
			pointer-events: auto;
			.text {
				opacity: 1;
				visibility: visible;
				top: -2em;
			}
		}
	}
}
</style>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/SearchPosition.vue